import { render } from "./Tax.vue?vue&type=template&id=3f1b2a64"
import script from "./Tax.vue?vue&type=script&lang=js"
export * from "./Tax.vue?vue&type=script&lang=js"

import "./Tax.vue?vue&type=style&index=0&id=3f1b2a64&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__